module.exports = __webpack_public_path__ + "img/组 2941.e174b6ed.svg";